import { polyfill } from './polyfill';
import { Environment } from '../environment';
import { Navigation } from '../integrations/navigation/navigation';
import { ScopeFilter } from '../integrations/scopeFilter/scopeFilter';
import { EventDispatcher } from '../events/eventDispatcher';
import { NewFeatureTag } from '../newFeatureTag/newFeatureTag';
import { applyInitialPageFeatureGates } from '../integrations/featureGates/featureGates';

$(document).ready(async () => {
    await Promise.all([
        polyfill(),
        window.whenLoadedCurrentLanguageTexts,
    ]);

    try {
        const env = Environment.instance;

        Navigation.create(env);
        ScopeFilter.create(env);

        // Since we define scope rules in each page we have to at least initialize them, so we can read them
        const resolution = await env.preparePages();

        Navigation.instance.initializeMobileNav();
        Navigation.instance.setCurrentMenuFromPath(resolution.ctx.pathname);

        if (ScopeFilter.instance.filtersManagement !== undefined) {
            await ScopeFilter.instance.initialize();
        }

        EventDispatcher.global.on('FilteredPage.filterSelect', () => {
            Navigation.instance.refreshFeatureFlagsForCurrentScope();
        });

        NewFeatureTag.instance.initAll();
        env.initializeLegacyFeatures();

        applyInitialPageFeatureGates();

        await env.renderCurrentPage(resolution);
    } catch (err) {
        console.error(err);
    }
});
